import { base } from "../../common/config";
import axios from 'axios'

export  const SetPermissionByRole=function (AdminRoleId,AdminMenuIds) {
  return axios({
    url:`${base}/api/Privilege/Permission/SetPermissionByRole?RoleId=${AdminRoleId}`,
    data:AdminMenuIds,
    method:'POST'
  })
}
export const GetAdminPermissionAdminMenu=function () {
  return axios({
    url:`${base}/api/Privilege/Permission/GetUserPermissionTreeData`,
    method:"GET"
  })
}


export const GetPermissionByRoleForEdit=function (AdminRoleId) {
  return axios({
    url:`${base}/api/Privilege/Permission/GetPermissionByRoleForEdit?RoleId=${AdminRoleId}`,
    method:'GET'
  })
}



// WEBPACK FOOTER //
// ./src/api/privilege/permission.js